import { render, staticRenderFns } from "./PageHeaderSlot.vue?vue&type=template&id=28ffaa30&scoped=true&"
import script from "./PageHeaderSlot.vue?vue&type=script&lang=js&"
export * from "./PageHeaderSlot.vue?vue&type=script&lang=js&"
import style0 from "./PageHeaderSlot.vue?vue&type=style&index=0&id=28ffaa30&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ffaa30",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VIcon,VRow})
